module.exports = __webpack_public_path__ + "static/media/xinyuangongruzhigaozhishu.96562844.png";